import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	SxProps,
	Typography,
	styled,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { combineSX } from '@/utils/combineSX';

const CustomAccordion = styled(Accordion)({
	borderBottom: '1px solid rgba(0, 0, 0, .125)',
});

const CustomAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
	fontSize: 'var(--font-size-default)',
	fontWeight: 'bold',
	[theme.breakpoints.down('md')]: {
		fontSize: 'var(--font-size-caption)',
	},
}));

export const DpAccordionSeason = ({
	id,
	summary,
	children,
	accordionsx,
	summarysx,
	detailsx,
	defaultexpanded,
	isfirst,
	islast,
	componenttitle = 'h3',
	nouppercase,
	...props
}: {
	id: string;
	summary: string;
	accordionsx?: SxProps;
	summarysx?: SxProps;
	detailsx?: SxProps;
	children: React.ReactNode;
	defaultexpanded?: boolean;
	isfirst?: boolean;
	islast?: boolean;
	componenttitle?: string;
	nouppercase?: boolean;
}) => (
	<CustomAccordion
    disableGutters
		elevation={0}
		square={false}
		defaultExpanded={defaultexpanded}
		{...props}
		sx={combineSX([
			{
				borderBottomLeftRadius: '0px !important',
				borderBottomRightRadius: '0px !important',
				borderBottom: islast ? 'none' : '1px solid #E2E2E2',
				backgroundColor: 'transparent',
			},
			...(Array.isArray(accordionsx) ? accordionsx : [accordionsx]),
		])}
	>
		<CustomAccordionSummary
			expandIcon={<ExpandMoreIcon />}
			id={id}
			aria-controls={id}
			sx={combineSX([
				{
					borderTop: isfirst ? '1px solid #E2E2E2' : 'none',
					padding: '0px',
				},
				...(Array.isArray(summarysx) ? summarysx : [summarysx]),
			])}
		>
			<Typography
				component={componenttitle as React.ElementType}
				sx={combineSX([
					{
						fontSize: { xs: 'var(--font-size-default)', md: 'var(--font-size-lg)' },
						fontWeight: '600',
						pt: { xs: '15px', sm: '21px' },
						pb: { xs: '15px', sm: '21.5px' },
						color: '#2a2a2a',
					},
					...(Array.isArray(summarysx) ? summarysx : [summarysx]),
				])}
			>
				{summary}
			</Typography>
		</CustomAccordionSummary>
		<AccordionDetails
			sx={combineSX([
				{
					paddingLeft: '0px',
					fontSize: { xs: 'var(--font-size-default)', md: 'var(--font-size-body)' },
				},
				detailsx,
			])}
		>
			{children}
		</AccordionDetails>
	</CustomAccordion>
);
